import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bf-card bf-chart-card" }
const _hoisted_2 = { class: "chart yourProgressChart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "bf-chart-card__head" }, [
      _createElementVNode("div", { class: "bf-chart-card__title" }, "Registros integrados no tempo"),
      _createElementVNode("div", { class: "bf-chart-card__legend" }, [
        _createElementVNode("span", { class: "bf-chart-card__legend-line" }),
        _createTextVNode(" Registros integrados ")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_LineChart, {
        width: 300,
        height: 300,
        data: _ctx.chartData,
        options: _ctx.chartOptions
      }, null, 8, ["data", "options"])
    ])
  ]))
}